import { Container } from "@mui/material"
import ScreenBanner from "../../components/ScreenBanner"
import PermissionGuard from "../../components/PermissionGuard"

export default function Cafe() {
    return (
        <>
            <ScreenBanner color="#7D3600" title="Café" />

            <PermissionGuard permissionId="cafe.dashboard">
                <Container>
                    <h2>Dashboard do Café</h2>
                    <p>Conteúdo protegido por permissão</p>
                </Container>
            </PermissionGuard>
        </>
    )
}